
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for CostRoyalty Action/Mutation Types. Use it in   costs/actions.js, accounts/mutations.js and the Vuex Host Component 
export const CostData = createActionTypeModel('CostData');
export const CostsList = createActionTypeModel('CostsList');
export const CostsDetails = createActionTypeModel('CostsDetails');
export const AccountingCostsContacts = createActionTypeModel('AccountingCostsContacts');
export const AccountingCostsInvoice = createActionTypeModel('AccountingCostsInvoice');
export const AccountingCostPayments = createActionTypeModel('AccountingCostPayments');
export const PaymentCurrency = createActionTypeModel('PaymentCurrency');
export const AccountingCostLines = createActionTypeModel('AccountingCostLines');
export const AccountingCostSplits = createActionTypeModel('AccountingCostSplits');
export const AccountingCostRecopables = createActionTypeModel('AccountingCostRecopables');
export const AccountingCostOverview = createActionTypeModel('AccountingCostOverview');
export const SET_COSTS_FILES = "SET_COSTS_FILES";
export const InvoiceTotalCostSplit = createActionTypeModel('InvoiceTotalCostSplit');
export const CHANGE_COST_TAX_DEDUC = 'CHANGE_COST_TAX_DEDUC';
export const FETCH_ONLY_COST_INVOICE = 'FETCH_ONLY_COST_INVOICE';